import { render, staticRenderFns } from "./DisputeOverview.vue?vue&type=template&id=756c3a31&"
import script from "./DisputeOverview.vue?vue&type=script&lang=js&"
export * from "./DisputeOverview.vue?vue&type=script&lang=js&"
import style0 from "./DisputeOverview.vue?vue&type=style&index=0&id=756c3a31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports